import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { AdaptabilitySection } from '../components/AdaptabilitySection';
import { CTASection } from '../components/CTASection';
export function LandingPage() {
  return <main className="min-h-screen" data-id="element-50">
      <HeroSection data-id="element-51" />
      <ProblemSection data-id="element-52" />
      <SolutionSection data-id="element-53" />
      <AdaptabilitySection data-id="element-54" />
      <CTASection data-id="element-55" />
    </main>;
}